import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FondsPropresService } from "src/app/fonds-propres/services/fonds-propres.service";
import { ParametreNotation } from "./../../../models/ParametreNotation";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-notation-modal",
  templateUrl: "./notation-modal.component.html",
  styleUrls: ["./notation-modal.component.scss"],
})
export class NotationModalComponent implements OnInit {
  form: FormGroup;
  pressButton: Boolean = false;
  //From DB
  parametreNotation: ParametreNotation;
  title: string;
  loading = false;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private shared: FondsPropresService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.form = this.createForm(this.parametreNotation);
  }

  createForm(data: any) {
    return this.fb.group({
      id: [data ? data.id : ""],
      codeRule: [
        data ? data.codeRule : "",
        Validators.compose([Validators.required]),
      ],
      codeNotation: [
        data ? data.codeNotation : "",
        Validators.compose([Validators.required]),
      ],
      libelleNotation: [
        data ? data.libelleNotation : "",
        Validators.compose([Validators.required]),
      ],
      isActive: [data ? data.isActive : ""],
      codeSegmentPrudentiel: [
        data ? data.codeSegmentPrudentiel : "",
        Validators.compose([Validators.required]),
      ],
      ponderation: [
        data ? data.ponderation : "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
        ]),
      ],
    });
  }

  onSubmit() {
    this.submitted = true;
    // reset alerts on submit
    //this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    if (!this.parametreNotation) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  updateData() {
    this.shared.updateParametreNotation(this.form.value).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      },
      () => {
        //redirectTo
        //window.location.reload();
        //this.tabGroup.selectedIndex = 1;
      }
    );
  }

  createData() {
    this.shared.saveParametreNotation(this.form.value).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      },
      () => {
        //redirectTo
        //window.location.reload();
        //this.tabGroup.selectedIndex = 1;
      }
    );
  }
}
